module.exports = __webpack_public_path__ + "img/victrix-bretelle-6.61340246.jpg";